import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import moment from 'moment';
import 'moment/locale/de'
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { orderBy } from '../common/orderby';
import { format } from 'react-string-format';

export class PlansEditor extends Component {
  static propTypes = {
    seasonId: PropTypes.number.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {

    let currentSeason = this.props.home.seasons[this.props.seasonId];
    let plans = Object.values(this.props.home.plans).filter(p => p.date >= currentSeason.from && p.date <= currentSeason.to);

    return (
      <div className="home-plans-editor">
      <Table>
        <TableHead>
          <TableCell>Datum</TableCell>
          <TableCell>Standort</TableCell>
          <TableCell>PCO-Titel</TableCell>
          <TableCell>Team benötigt?</TableCell>
          <TableCell>Tour</TableCell>
          <TableCell>Hinweis für Umfrage (z.B. "Probe Mittwochs")</TableCell>
          <TableCell></TableCell>
        </TableHead>
      
        {orderBy(plans,p => [p.date, p.location]).map(p => 
          <TableRow id={"plan"+p.id}>
            <TableCell>{moment.utc(p.date).format("DD.MM.YYYY (ddd)")}</TableCell>
            <TableCell>{p.location}</TableCell>
            <TableCell><Link target="_blank" href={format(this.props.home.webClientConfig.planUrl,p.pcoPlanId)}>{p.comment || "kein Titel"}</Link></TableCell>
            <TableCell><Checkbox checked={p.teamRequired} onChange={(event) => {this.props.actions.updatePlan({...p, teamRequired: event.target.checked})}} /></TableCell>
            <TableCell>
            <Select
          value={p.tourOption}
          onChange={(event) => {this.props.actions.updatePlan({...p, tourOption: event.target.value})}}
          inputProps={{
            name: 'tour',
            id: 'tour',
          }}
        >
            <MenuItem value={0}>Nie Tour planen</MenuItem>
            <MenuItem value={1}>Evtl. Tour planen</MenuItem>
            <MenuItem value={2}>Immer Tour planen</MenuItem>

        </Select>


              </TableCell>
            <TableCell><TextField defaultValue={p.dateRestriction} 
             onChange={(event) => {this.props.actions.updatePlan({...p, dateRestriction: event.target.value})}}
               /></TableCell>
            <TableCell></TableCell>
          </TableRow>

          )}
          </Table>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlansEditor);



// WEBPACK FOOTER //
// ./src/features/home/PlansEditor.js